(function() {
  'use strict'
  const routerLeft = document.querySelector('.router-left')
  const routerRight = document.querySelector('.router-right')
  const parentRouter = document.querySelector('.router')

  if (!parentRouter) {
    return
  }

  function mouseEnter(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.target.getAttribute('data-router')) {
      e.target.classList.add('router--hover')
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.classList.add('shrink')
      }
      if (e.target.previousElementSibling) {
        e.target.previousElementSibling.classList.add('shrink')
      }
    }
  }

  function mouseLeave(e) {
    e.preventDefault()
    e.stopPropagation()
    if (e.target.getAttribute('data-router')) {
      e.target.classList.remove('router--hover')
      if (e.target.nextElementSibling) {
        e.target.nextElementSibling.classList.remove('shrink')
      }
      if (e.target.previousElementSibling) {
        e.target.previousElementSibling.classList.remove('shrink')
      }
    }
  }

  function keyboardFocus(e) {
    e.stopPropagation()
    if (e.target.nodeName === 'DIV') {
      e.target.classList.add('router--hover')
      const lastLink = e.target.querySelector('a:last-of-type')
      lastLink.addEventListener('focusout', () => {
        e.target.classList.remove('router--hover')
      })
    }
  }

  if (routerLeft) {
    routerLeft.addEventListener('focusin', keyboardFocus)
    routerLeft.addEventListener('mouseenter', mouseEnter)
    routerLeft.addEventListener('mouseleave', mouseLeave)
  }

  if (routerRight) {
    routerRight.addEventListener('focusin', keyboardFocus)
    routerRight.addEventListener('mouseenter', mouseEnter)
    routerRight.addEventListener('mouseleave', mouseLeave)
  }

})(window);
